export default "__VITE_ASSET__7RF4S6yn__"